module.exports = __webpack_public_path__ + "static/news5pic6-2a61449a729dbec82425ecd632062e42.jpg";